function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.23 141.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.4,
    cy: 22.83,
    r: 22.83,
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.54 1.56 100.54 58.79 100.54 62.51 100.54 134.31 100.54 138.03 100.54 141.75 100.59 141.75 137.2 141.75 137.2 1.56 100.54 1.56",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.55,1.55v57.5h-17a37.88,37.88,0,0,0-37.87,37.89h0v6.94a37.88,37.88,0,0,0,37.89,37.87h53.67V1.55Zm0,134.35h-7.42A10.86,10.86,0,0,1,390.27,125V76.69a10.86,10.86,0,0,1,10.86-10.86h7.42Z",
    transform: "translate(0 0)",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.2 141.72 445.2 141.75 408.55 141.75 408.55 141.74 445.2 141.72",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,100.05v.27h0Z",
    transform: "translate(0 0)",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.33,103.42V96.9h0A37.86,37.86,0,0,0,304.49,59H288.68a37.88,37.88,0,0,0-37.87,37.91v7a37.89,37.89,0,0,0,37.9,37.87h53.63ZM298.28,135.9A10.87,10.87,0,0,1,287.41,125V76.69a10.87,10.87,0,0,1,10.87-10.86h7.86V135.9Z",
    transform: "translate(0 0)",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,100.73h54.91V96.9a37.25,37.25,0,0,0-.37-5.27A37.89,37.89,0,0,0,201.78,59H186a37.88,37.88,0,0,0-37.88,37.9h0v6.94A37.88,37.88,0,0,0,186,141.71h15.75A37.9,37.9,0,0,0,239.17,110h-35.7v16.58a9.36,9.36,0,1,1-18.72,0h0Zm0-25.54a9.36,9.36,0,1,1,18.72,0V91.63H184.75Z",
    transform: "translate(0 0)",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo--dot",
    points: "49.09 61.25 49.09 92.39 49.09 92.39 49.09 95.65 49.09 141.49 79.24 111.34 79.24 61.25 49.09 61.25",
    style: {
      fill: "#282828"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "logo-red",
    points: "30.14 61.25 0 91.39 45.84 91.39 49.09 91.39 49.09 61.25 30.14 61.25",
    style: {
      fill: "#ff1d1d"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a786f02bbe4d0ee39bf15778580f20ea.svg";
export { ForwardRef as ReactComponent };